/**
 * Texts for Library page
 */
export const libraryPageText = {
    title: 'CamAPS Liberty - CamAPS FX',
    titleMeta: 'CamAPS Liberty - CamAPS FX',
    descriptionMeta: 'Tillgång till resurser och stödmaterial för CamAPS FX och CamAPS Liberty®.',
    keywords: 'camaps bibliotek, camaps fx, camaps liberty, stödresurser, diabeteshantering',
    localeMeta: 'sv_se',

    bannerTitle: 'Stöd bortom siffrorna',
    bannerSubtitle: 'med CamAPS Liberty<sup>®</sup>',
    bannerDescription: 'När den är aktiverad behöver användare inte räkna kolhydrater och ge en för-måltids insulinbolus.',
    bannerCompatibility: 'Kompatibel med Android och iOS',
    
    announcementText: 'Nu tillgängligt i myLoop',
    announcementDisclaimer: '',

    introTitle: 'Den första helt slutna loop-funktion. När du behöver den.',
    introDescription: 'När den är aktiverad behöver användare inte räkna kolhydrater och ge en för-måltids insulinbolus.',
    introSubtext: 'Tillgänglig på Android- och Apple-operativsystem',

    howItWorksTitle: 'Hur fungerar det?',
    howItWorksDescription: 'Drivs av en mer proaktiv version av CamAPS-algoritmen. CamAPS Liberty förutser och svarar på glukosförändringar samtidigt som etablerade säkerhetsgränser upprätthålls.',
    
    step1Title: 'STEG 1',
    step1Description: 'Gå från din startsida till inställningsmenyn.',
    step2Title: 'STEG 2',
    step2Description: 'Rulla ner till botten och tryck på växeln för att aktivera.',
    step3Title: 'STEG 3',
    step3Description: 'Vid första användningen måste du titta på vår förklarande video om CamAPS Liberty.',
    step4Title: 'STEG 4',
    step4Description: 'Bekräfta att du inte är under 13 år eller gravid.',
    step5Title: 'STEG 5',
    step5Description: 'Tryck på växeln igen för att aktivera.',
    step6Title: 'STEG 6',
    step6Description: "Klart! CamAPS Liberty-fliken visas på din startsida<sup>†</sup>.",
    step6Footnote: "<sup>†</sup> Fungerar endast när \"Auto mode\" är aktiverat",

    eligibilityTitle: 'Vem kan använda CamAPS Liberty?',
    eligibilityCriterion1: 'Befintliga användare med typ 1-diabetes',
    eligibilityCriterion2: '13 år och äldre',
    eligibilityCriterion3: 'Gravid',
    parentsCarersTitle: 'Hur är det med föräldrar och vårdgivare?',
    parentsCarersBlockTitle: 'Funktionen "Blockera":',
    parentsCarersBlockDescription: 'För att förhindra oavsiktlig användning',
    parentsCarersRemoteTitle: 'Fjärrövervakning:',
    parentsCarersRemoteDescription: 'Companion, Glooko® och CamAPS 2-veckors PDF-rapporter',

    imageOverlayText: 'Designad för att fungera tillsammans med din nuvarande diabeteshanteringsplan; inte för att ersätta den.',
    
    usingTitle: 'Använda CamAPS Liberty',
    
    treatmentPlanText: 'CamAPS Liberty är utformad för att eliminera behovet av rutinmässiga måltidsbolusar. Funktionen ersätter inte övriga delar av användarens diabetesbehandlingsplan, inklusive regelbunden uppföljning med diabetesteamet.',
    
    usingLibertyTitle: 'Titta och lär dig om CamAPS Liberty',
    usingLibertyDescription: 'Utforska videor för att lära dig mer om CamAPS Liberty och hur du kommer igång.',
    // latestVideoLabel removed
    moreVideosLabel: 'Fler videor',
    factsheetDownloadText: 'CamAPS Liberty-faktablad (pdf)',
    factsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_se.pdf',
    usingLibertyFeaturedVideo: {
        youtubeUrl: 'https://youtu.be/px9QSOhy544',
        title: 'CamAPS Liberty: Kom igång',
        description: 'Candice Ward förklarar hur du ställer in och börjar använda CamAPS Liberty.',
        duration: '31:50',
        date: '15 Sep 2026',
    },
    usingLibertyMoreVideos: [
        {
            youtubeUrl: 'https://youtu.be/k0Sc4M5ywOk',
            title: 'Praktiska Tips: CamAPS Liberty',
            duration: '02:28',
        },
        {
            youtubeUrl: 'https://youtu.be/K7_j-Sk5Fas',
            title: 'Introduktion till CamAPS Liberty',
            duration: '14:42',
        },
        {
            youtubeUrl: 'https://youtu.be/0dp5A8z_SEk',
            title: 'Den där fully closed-loop-känslan',
            duration: '04:22',
        },
        {
            youtubeUrl: 'https://youtu.be/sFYq9TgVxhM',
            title: 'Funktionen CamAPS Liberty',
            duration: '03:52',
        }
    ],
    
    whatHappensNextTitle: 'Vad händer härnäst?',
    whatHappensNextText: 'Vi kommer att köra en pilot inom en enda marknad under de kommande månaderna. Håll utkik efter fler detaljer.',
};

